import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Location } from '@angular/common';

import * as rootReducer from '../../store';
import * as fromSelectors from '../../store/selectors';

@Component({
  standalone: false,
  selector: 'pptl-delivery-lock-layout',
  templateUrl: 'delivery-lock-layout.component.html',
  styleUrls: ['../layout-component.scss', 'delivery-lock-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryLockLayoutComponent implements OnInit, OnDestroy {
  public isLogined: boolean;
  private isLoginedSubscr: Subscription;

  constructor(
    private location: Location,
    private store: Store<rootReducer.State>,
  ) {}

  ngOnInit() {
    this.isLoginedSubscr = this.store
      .pipe(select(fromSelectors.getAuthRefreshToken))
      .subscribe((res) => {
        this.isLogined = !!res;
      });
  }

  ngOnDestroy() {
    this.isLoginedSubscr.unsubscribe();
  }

  onBackClick(): void {
    // todo : need to clarify where should be redirect after click button 'back' on lock screen
    this.location.back();
  }

  get isDevicePlatform(): boolean {
    return false;
  }

  get isDesktop(): boolean {
    return true;
  }
}
